import CryptoJS from 'crypto-js';

const useEncryptDecrypt = () => {
  const encryptDecryptData = ({ data, secretPass, encrypt = false, isObjectData }) => {
    try {
      
      if (!isObjectData || !data || data.length === 0 || Object.keys(data).length === 0) {
        return null;
      }
      
      const key = CryptoJS.enc.Utf8.parse(secretPass);
      const iv = CryptoJS.enc.Utf8.parse(secretPass.substring(0, 16));
      
      if (encrypt) {
        // Convert the object to a string before encryption
        const dataString = JSON.stringify(data);
        const encrypted = CryptoJS.AES.encrypt(isObjectData ? dataString : data, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
        return encrypted.toString();
      } else {
        const cleanedData = data.replaceAll(/ /g, '+');
        cleanedData.replaceAll(" ", "+");
        const decrypted = CryptoJS.AES.decrypt(cleanedData, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
        const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
        return typeof isObjectData ?
           JSON.parse(decryptedString) : decryptedString;
      }
    } catch (error) {
      // Handle encryption/decryption error
      console.error("Encryption/Decryption error:", error);
      return ''; // or handle error in your own way
    }
  };
  return encryptDecryptData;
};
export default useEncryptDecrypt;